import { Button, EButtonColorVariant } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import Heading from '@/components/switchback/Heading/Heading';

interface IPageEmptyStateProps {
  icon: React.ReactNode;
  title: React.ReactNode;
  description: React.ReactNode;
  actions?: React.ReactNode;
  isAuto?: boolean;
}

export const PageEmptyState: React.FC<IPageEmptyStateProps> = ({
  icon,
  title,
  description,
  actions,
  isAuto,
}) => {
  const intl = useIntl();

  return (
    <div className="flex flex-col items-center">
      {icon}

      <Heading level={3} className="mt-8 font-bold text-gray-900 font-highlight autoType700">
        {title}
      </Heading>

      <div className="mt-4 text-center text-gray-900 autoType500">{description}</div>

      {actions ?? (
        <Button
          className="w-full mt-8 md:w-auto"
          href={isAuto ? '/auto/car-search' : '/rv-search'}
          variant={EButtonColorVariant.Primary}
          label={
            isAuto
              ? intl.formatMessage({ defaultMessage: 'Browse Vehicles', id: 'crqnsU' })
              : intl.formatMessage({ defaultMessage: 'Search RVs', id: 'bMef/4' })
          }
        />
      )}
    </div>
  );
};
